import { Collection } from 'modules/core/lib/mobx-rest'

import QuestionCategory from 'modules/surveys/store/models/QuestionCategory'

class QuestionCategories extends Collection<QuestionCategory> {
  get cacheKey(): string {
    return 'surveysQuestionCategories'
  }
  model() {
    return QuestionCategory
  }
}

export default new QuestionCategories()
